<template>
  <div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                ref="form"
                :model="form"
                :inline="true"
                style="padding: 10px"
              >
                <el-form-item>
                  <el-input
                    v-model="form.check_record_id"
                    placeholder="差异单号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.package_no"
                    placeholder="包裹号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.package_type"
                    clearable
                    multiple
                    :multiple-limit="10"
                    placeholder="包裹类型"
                  >
                    <el-option
                      v-for="item in options.package_type"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item class="_form-item">
                  <el-select
                    v-model="form.supply_id"
                    filterable
                    clearable
                    remote
                    :remote-method="fetchSupply"
                    placeholder="商家"
                  >
                    <el-option
                      v-for="item in options.supply"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.market_id"
                    clearable
                    placeholder="市场"
                  >
                    <el-option
                      v-for="item in options.market"
                      :key="item.market_id"
                      :value="item.market_id"
                      :label="item.market_name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.city"
                    clearable
                    multiple
                    :multiple-limit="10"
                    placeholder="城市"
                  >
                    <el-option
                      v-for="item in options.supply_city"
                      :key="item.key"
                      :value="item.key"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.pgid"
                    placeholder="代采组"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in options.pg_group"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pg_member_id"
                    placeholder="代采员"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in options.pg_member"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.verify_status"
                    placeholder="处理状态"
                    clearable
                  >
                    <el-option
                      v-for="item in options.verify_status"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="反馈时间">
                  <el-date-picker
                    v-model="form.feedback_at"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="起始日期"
                    end-placeholder="截止日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="包裹生成时间">
                  <el-date-picker
                    v-model="form.package_add_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="起始日期"
                    end-placeholder="截止日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label-width="0">
                  <el-button @click="handleReset">重置</el-button>
                </el-form-item>
                <el-form-item label-width="0">
                  <el-button type="primary" @click="handleSearch">
                    查询
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div style="display: inline-block; width: 60%">数据列表：</div>
          <div style="display: inline-block; text-align: right; width: 40%">
            <el-button size="mini" type="success" @click="handleListExport">
              导出列表</el-button
            >
            <el-button size="mini" type="success" @click="handleDetailExport">
              导出差异明细</el-button
            >
          </div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              label="差异单号"
              prop="id"
              width="100"
              fixed="left"
            ></el-table-column>
            <el-table-column
              align="center"
              label="商家名称"
              prop="supply_name"
              width="100"
            ></el-table-column>
            <el-table-column align="center" width="100">
              <div slot="header">
                <div>开单方式/</div>
                <div>城市/</div>
                <div>市场/</div>
                <div>代采员/</div>
              </div>
              <template #default="{ row }">
                <div>{{ row.billing_type_txt }}</div>
                <div>{{ row.city_txt }}</div>
                <div>{{ row.market_name }}</div>
                <div>{{ row.pg_member_name }}</div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="package_type_txt"
              label="包裹类型"
              width="100"
            >
            </el-table-column>
            <el-table-column align="center" width="100">
              <div slot="header">
                <div>包裹号/</div>
                <div>生成时间/</div>
              </div>
              <template #default="{ row }">
                <div>{{ row.package_no }}</div>
                <div>{{ row.spr_create_time }}</div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="total_amount_received"
              label="一手总收货件数"
              width="100"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="no_goods_nums"
              label="无数据件数（不含已入库）"
              width="100"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="stock_num"
              label="一手已入库件数（当前实时）"
              width="100"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="num"
              label="商家配货件数"
              width="100"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="check_sku_num"
              label="差异SKU个数"
              width="100"
            >
            </el-table-column>

            <el-table-column align="center" width="100">
              <div slot="header">
                <div>当前入库差异件数/</div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="入库差异件数 = 一手已入库件数 - 商家配货件数"
                  placement="top-start"
                >
                  <i class="el-icon-question" />
                </el-tooltip>
              </div>
              <template #default="{ row }">
                <NumColorCell :num="row.check_goods_num" />
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="verify_status_txt"
              label="处理状态"
              width="100"
            >
            </el-table-column>
            <el-table-column align="center" width="100">
              <div slot="header">
                <div>商家反馈人/</div>
                <div>时间</div>
              </div>
              <template #default="{ row }">
                <div v-if="row.user_name && row.created_at">
                  <div>{{ row.user_name }}（爆版id：{{ row.user_id }}）</div>
                  <div>{{ row.created_at }}</div>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="100">
              <div slot="header">
                <div>仓库核实人/</div>
                <div>时间</div>
              </div>
              <template #default="{ row }">
                <div
                  v-if="
                    row.warehouse_admin_name && row.warehouse_verify_time_txt
                  "
                >
                  <div>{{ row.warehouse_admin_name }}</div>
                  <div>{{ row.warehouse_verify_time_txt }}</div>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column
              width="100"
              align="center"
              prop="warehouse_time_consuming"
              label="仓库核实耗时"
            >
            </el-table-column>

            <el-table-column align="center" width="100">
              <div slot="header">
                <div>商家申诉人/</div>
                <div>时间</div>
              </div>
              <template #default="{ row }">
                <div v-if="row.supply_reason && row.supply_reason_time_txt">
                  <div>
                    {{ row.supply_reason }}（爆版id：{{ row.user_id }}）
                  </div>
                  <div>{{ row.supply_reason_time_txt }}</div>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="100">
              <div slot="header">
                <div>申诉处理人/</div>
                <div>时间</div>
              </div>
              <template #default="{ row }">
                <div
                  v-if="
                    row.complain_handling_admin_name &&
                    row.complain_handling_time_txt
                  "
                >
                  <div>{{ row.complain_handling_admin_name }}</div>
                  <div>{{ row.complain_handling_time_txt }}</div>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column
              width="100"
              align="center"
              prop="complain_handling_time_consuming"
              label="申诉处理耗时"
            >
              <template #default="{ row }">
                <div v-if="row.complain_handling_time_consuming">
                  <div>{{ row.complain_handling_time_consuming }}</div>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" fixed="right">
              <template #default="{ row }">
                <el-button type="text" @click="handleDetail(row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="sizes,total, prev, pager, next,jumper "
            :total="resData.count"
            :page-size.sync="form.page_size"
            :page-sizes="[10, 20, 30, 50, 100]"
            @current-change="handleCurrentChange"
            @size-change="pageSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dayjs from "dayjs";
import NumColorCell from "@//pages/receiveGoods/StockVarianceProcess/components/NumColorCell.vue";
import { postGetList } from "@/openapi/erp/supplyPackageCheckRecord.js";
import apiBaseURL from "@/utils/baseUrl.js";
import * as commonApi from "@/openapi/erp/common.js";

const constantMap = {
  VERIFY_STATUS_OPTION: [
    {
      label: "仓库待核实",
      value: "1",
    },
    {
      label: "仓库已核实",
      value: "2",
    },
    {
      label: "申诉待处理",
      value: "3",
    },
    {
      label: "申诉已处理",
      value: "4",
    },
  ],
  PACKAGE_TYPE_OPTION: [
    {
      label: "大货",
      value: "1",
    },
    {
      label: "前置仓",
      value: "2",
    },
  ],
  FETCH_TYPE_MAP: {
    showList: 0,
    exportList: 1,
    exportDetail: 2,
  },
};

export default {
  components: {
    NumColorCell,
  },
  data() {
    return {
      constantMap,
      resData: {
        count: 0,
        list: [],
      },
      tableLoading: false,
      form: {
        check_record_id: "",
        package_no: "",
        package_type: [],
        supply_id: "",
        market_id: "",
        city: [],
        pgid: "",
        pg_member_id: "",
        verify_status: "",
        feedback_at: [],
        package_add_time: [],
        export: 0, // 导出类型:0 不导出、 1、导出列表 2、导出差异明细
        page: 1,
        page_size: 10,
      },
      options: {
        supply: [],
        market: [],
        pg_group: [],
        pg_member: [],
        supply_city: [],
        verify_status: constantMap.VERIFY_STATUS_OPTION,
        package_type: constantMap.PACKAGE_TYPE_OPTION,
      },
      filterFold: false,
      curPage: 1,
      recoverlist: [{ num: 0, recoverNum: 0 }],
      recoverDialogVisible: false,
    };
  },
  computed: {
    filteredForm() {
      const result = { ...this.form }; // 创建 form 对象的副本
      // eslint-disable-next-line no-restricted-syntax
      for (const key in result) {
        if (
          result[key] === undefined ||
          result[key] === "" ||
          result[key] === null
        ) {
          delete result[key];
        }
      }
      return result;
    },
  },
  created() {
    this.getOptions();
    this.setDefaultFeedbackDate();
    this.fetchData("showList");
  },
  methods: {
    handleListExport() {
      this.fetchData("exportList");
    },

    handleDetailExport() {
      this.fetchData("exportDetail");
    },
    setDefaultFeedbackDate() {
      const today = dayjs().format("YYYY-MM-DD");
      const priorDate = dayjs().subtract(31, "day").format("YYYY-MM-DD");
      this.form.feedback_at = [priorDate, today];
    },
    async getOptions() {
      try {
        const [market, supplyCity, pgGroup, pgMember] = await Promise.all([
          commonApi.postGetFirstMarketList(),
          commonApi.getGetCityList(),
          commonApi.getSelectPg(),
          commonApi.postGetPurchaseMember(),
        ]);
        this.options.market = market;
        this.options.supply_city = supplyCity;
        this.options.pg_group = pgGroup;
        this.options.pg_member = pgMember;
      } catch (error) {
        console.error("getOptions error: ", error);
      }
    },
    async fetchData(fetchType) {
      this.form.export = constantMap.FETCH_TYPE_MAP[fetchType];
      const showLoading = fetchType === "showList";
      if (showLoading) {
        this.tableLoading = true;
      }
      try {
        const res = await postGetList(this.filteredForm);
        if (showLoading) {
          this.resData = res;
        } else {
          window.open(apiBaseURL + res.file);
        }
      } catch (err) {
        console.error("postGetList error: ", err);
      } finally {
        if (showLoading) {
          this.tableLoading = false;
        }
      }
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData("showList");
    },
    // 切换页面条数
    pageSizeChange(val) {
      this.form.page_size = val;
      this.handleCurrentChange(this.page);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    async fetchSupply(e) {
      try {
        const res = await commonApi.postFetchSupplyBySearch({ supply_name: e });
        this.options.supply = res;
      } catch (error) {
        console.error("fetchSupply error: ", error);
      }
    },
    handleReset() {
      this.form = this.$options.data().form;
      this.setDefaultFeedbackDate();
      this.$refs.form.resetFields();
      this.fetchData("showList");
    },
    handleSearch() {
      this.form.page = 1;
      this.fetchData("showList");
    },
    handleDetail(row) {
      this.$router.push(
        `/home/receive-goods/stock-variance-process-detail/${row.id}`
      );
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/receiveGoods/StockVarianceProcess/index.vue